import { accountBind, accountUnBind } from '@/server/api'
import { mapMutations, mapState } from 'vuex'
import log from '@/utils/log'
import { SOCIAL_CODE_KEY_MAP } from '@/enum/const'

export default {
  deta () {
    return {
    }
  },
  computed: {
    ...mapState({
      storeUserInfo: 'userInfo'
    })
  },
  methods: {
    ...mapMutations({
      refreshUserInfo: 'refreshUserInfo'
    }),
    // 绑定操作
    doBind (info) {
      console.log('==z==> doBind - 传入的信息', JSON.stringify(info))
      const params = {
        accessToken: info.token,
        bindInfo: {
          email: '',
          id: info.id,
          name: info.name
        },
        bindType: info.bindType,
        deviceId: localStorage.getItem('login-type') === 'account' ? localStorage.getItem('social-did') : localStorage.getItem('local-did'),
        deviceUuid: localStorage.getItem('login-type') === 'account' ? localStorage.getItem('social-duuid') : localStorage.getItem('local-duuid'),
        // deviceId: localStorage.getItem('social-did'),
        // deviceUuid: localStorage.getItem('social-duuid'),
        sessionKey: this.storeUserInfo.sessionKey
      }
      accountBind(params)
        .then(res => {
          // 游客绑定后 deviceid login
          localStorage.setItem('social_login_type', info.bindType)
          if (localStorage.getItem('login-type') === 'visitor') {
            this.$bus.$emit('after-bind-visitor-login', params)
            this.refreshUserInfo({ type: 'bind', bindRes: { ...res } })
            localStorage.removeItem('local-did')
            localStorage.removeItem('local-duuid')
          }
          this.bindHandler(res)
          log('bind_account_success', { bind_account_type: SOCIAL_CODE_KEY_MAP[`social_${info.bindType}`], account_info: info.name })
        })
        .catch(err => {
          if (err.code === 20018) {
            this.$Spin.hide()
            this.$dialog(
              {
                title: this.$t('web_tips_title'),
                text: this.$t('tips_already_bind'),
                confirmTxt: this.$t('test_confirm'),
                cancelTxt: this.$t('test_cancel')
              },
              () => {
                console.log('==z==> emit already-bind-to-login')
                this.$bus.$emit('already-bind-to-login', params)
                // 点击切换到已有账号，此时关闭绑定账号弹窗
                this.$bus.$emit('bind-checkout-old-account')
              }
            )
          } else {
            this.bindHandler(err)
          }
        })
    },
    // 解绑操作
    doUnBind (info) {
      console.log('==z==> doUnBind')
      const params = {
        accessToken: info.token,
        bindInfo: {
          email: info.email,
          id: info.id,
          name: info.name
        },
        bindType: info.bindType,
        deviceId: localStorage.getItem('login-type') === 'account' ? localStorage.getItem('social-did') : localStorage.getItem('local-did'),
        deviceUuid: localStorage.getItem('login-type') === 'account' ? localStorage.getItem('social-duuid') : localStorage.getItem('local-duuid'),
        sessionKey: this.storeUserInfo.sessionKey
      }
      accountUnBind(params)
        .then(res => {
          this.unbindHandler(res)
          this.refreshUserInfo({ type: 'unbind' })
          console.log('==z==> doUnBind then')
        })
        .catch(err => {
          console.log('==z==> doUnBind catch')
          this.unbindHandler(err)
        })
    }
  }
}
